import { DomStorageDisabledGuard } from './dom-storage-disabled/dom-storage-disabled.guard';
import { DomStorageDisabledComponent } from './dom-storage-disabled/dom-storage-disabled.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { AttemptLoginComponent } from './attempt-login/attempt-login.component';
import { AttemptLogoutComponent } from './attempt-logout/attempt-logout.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ErrorResolver } from './error.resolver';

const routes: Routes = [
  {
    path: 'dom-storage-disabled',
    component: DomStorageDisabledComponent,
    canActivate: [DomStorageDisabledGuard],
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    resolve: {
      error: ErrorResolver
    }
  },
  {
    path: '',
    component: AppComponent,
    canActivate: [DomStorageDisabledGuard],
    children: [
      { path: '', component: AttemptLoginComponent },
      { path: 'logout', component: AttemptLogoutComponent },
    ],
  },
  { path: '**', pathMatch: 'full', redirectTo: ''}
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
